// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"508":"2092c920","661":"968a9fea","784":"9407a704"}[chunkId] + ".css";
};